export const EVENTS = {
    sessionStart: 'session_start',
    onboardingStarted: 'OnboardingStarted',
    onboardingStartedSubmitted: 'OnboardingStartedSubmitted',
    onboardingEnterNameShown: 'OnboardingEnterNameShown',
    onboardingEnterNameSubmitted: 'OnboardingEnterNameSubmitted',
    onboardingRealTimeLocation: 'OnboardingRealTimeLocation',
    onboardingRealTimeLocationSubmitted: 'OnboardingRealTimeLocationSubmitted',
    onboardingPlaceAlerts: 'OnboardingPlaceAlerts',
    onboardingPlaceAlertsSubmitted: 'OnboardingPlaceAlertsSubmitted',
    onboardingCheckIn: 'OnboardingCheckIn',
    onboardingCheckInSubmitted: 'OnboardingCheckInSubmitted',
    onboardingLocationHistory: 'OnboardingLocationHistory',
    onboardingLocationHistorySubmitted: 'OnboardingLocationHistorySubmitted',
    onboardingSos: 'OnboardingSos',
    onboardingSosSubmitted: 'OnboardingSosSubmitted',
    onboardingTrack: 'OnboardingTrack',
    onboardingTrackSubmitted: 'OnboardingTrackSubmitted',
    onboardingPlace: 'OnboardingPlace',
    onboardingPlaceSubmitted: 'OnboardingPlaceSubmitted',
    onboardingAddPlace: 'OnboardingAddPlace',
    onboardingAddPlaceSkip: 'onboardingAddPlaceSkip',
    onboardingAddPlaceSubmitted: 'OnboardingAddPlaceSubmitted',
    onboardingPlaceaddedSubmitted: 'OnboardingPlaceaddedSubmitted',
    onboardingEnterEmailShown: 'OnboardingEnterEmailShown',
    onboardingEnterEmailSubmitted: 'OnboardingEnterEmailSubmitted',
    signupSuccess: 'AccountCreated',
    onboardingCreatingProfile: 'OnboardingCreatingProfile',
    onboardingCreatingProfileSubmitted: 'OnboardingCreatingProfileSubmitted',
    onboardingPaywallShown: 'OnboardingPaywallShown',
    onboardingPaywallChosen: 'OnboardingPaywallChosen',
    onboardingCheckoutShown: 'OnboardingCheckoutShown',
    cardMethodChosen: 'CardCheckoutChosen',
    googlePlayTapped: 'GooglePlayTapped',
    appleStoreTapped: 'AppleStoreTapped',
    subBuyTapped: 'SubBuyTapped',
    subscribed: 'PaywallSubscribed',
    subBuyClosed: 'PaywallClosed',
    paymentAnimationScreen: 'PaymentAnimationScreen',
    onboardingPaymentDecline: 'OnboardingPaymentDecline',
    onboardingDeclineTryAgain: 'OnboardingDeclineTryAgain',
    onboardingSuccessShown: 'OnboardingSuccessShown',
    onboardingDone: 'OnboardingDone',
};